import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

// Components
import NavTab from './NavTab';

// Helpers
import actions from '../../actions/FavoritesActions';
import { tabs, portfolioTypes } from '../../constants';

// Styles
import styles from './styles/NavTabs.scss';

class NavTabs extends React.Component {
    constructor(props) {
        super(props);

        this.currentTab = null;
        this.onClick = this.onClick.bind(this);
    }

    onClick(event, clickedTab) {
        this.currentTab = clickedTab;
        if (this.props.tab !== clickedTab) {
            this.props.setTabChanged(true);
        }
        if (clickedTab === tabs.FOLDERS) {
            this.props.setPortfolioTypes([portfolioTypes.FOLDER]);
            this.props.resetCreationState();
        } else if (clickedTab === tabs.ITEMS) {
            this.props.setPortfolioTypes([portfolioTypes.ITEMS]);
        }
        this.props.resetProjectId();
        this.props.setPortfolioIds([]);
        this.props.setTab(clickedTab);
        this.props.resetUiState();
    }

    render() {
        const { projectsEnabled = false, routerNavigation, tab } = this.props;
        return (
            <div className={styles.tabs} onClick={this.props.setBorder}>
                <NavTab
                    isSelected={
                        this.currentTab !== tabs.ITEMS || routerNavigation
                            ? tab === tabs.ITEMS
                            : false
                    }
                    key={tabs.ITEMS}
                    linkCopy="Items"
                    onClick={event => this.onClick(event, tabs.ITEMS)}
                />
                <NavTab
                    isSelected={
                        this.currentTab !== tabs.FOLDERS || routerNavigation
                            ? tab === tabs.FOLDERS || tab === tabs.FOLDER
                            : false
                    }
                    key={tabs.FOLDERS}
                    linkCopy="Folders"
                    onClick={event => this.onClick(event, tabs.FOLDERS)}
                />
                {projectsEnabled && (
                    <NavTab
                        isSelected={
                            this.currentTab !== tabs.PROJECTS || routerNavigation
                                ? tab === tabs.PROJECTS || tab === tabs.PROJECT
                                : false
                        }
                        key={tabs.PROJECTS}
                        linkCopy="Projects"
                        onClick={event => this.onClick(event, tabs.PROJECTS)}
                    />
                )}
                <NavTab
                    isSelected={
                        this.currentTab !== tabs.FOLLOWING || routerNavigation
                            ? tab === tabs.FOLLOWING
                            : false
                    }
                    key={tabs.FOLLOWING}
                    linkCopy="Following"
                    onClick={event => this.onClick(event, tabs.FOLLOWING)}
                />
                {routerNavigation ? null : (
                    <div className={styles.border} style={this.props.borderStyle} />
                )}
            </div>
        );
    }
}

NavTabs.propTypes = {
    borderStyle: PropTypes.object,
    projectsEnabled: PropTypes.bool,
    resetCreationState: PropTypes.func,
    resetProjectId: PropTypes.func,
    resetUiState: PropTypes.func,
    routerNavigation: PropTypes.bool,
    setBorder: PropTypes.func,
    sticky: PropTypes.bool,
    setPortfolioIds: PropTypes.func,
    setPortfolioTypes: PropTypes.func,
    setTab: PropTypes.func,
    setTabChanged: PropTypes.func,
    tab: PropTypes.string,
};

const mapStateToProps = state => {
    return {
        routerNavigation: state.favorites.uiState.routerNavigation,
        tab: state.favorites.uiState.tab,
    };
};

const mapDispatchToProps = dispatch => {
    return {
        resetCreationState: () => {
            dispatch(actions.resetCreationState());
        },
        resetProjectId: () => {
            dispatch(actions.setProjectId({ projectId: '' }));
        },
        resetUiState: () => {
            dispatch(actions.resetUiState());
        },
        setModalOpen: modalOpen => {
            dispatch(actions.setModalOpen({ modalOpen }));
        },
        setPortfolioIds: portfolioIds => {
            dispatch(actions.setPortfolioIds({ portfolioIds }));
        },
        setPortfolioTypes: types => {
            dispatch(actions.setPortfolioTypes({ portfolioTypes: types }));
        },
        setTab: tab => {
            dispatch(actions.setTab({ tab }));
        },
        setTabChanged: tabChanged => {
            dispatch(actions.setTabChanged({ tabChanged }));
        },
    };
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(NavTabs);
